<template>
  <div class="review-swiper myText_wrap">
    <p class="wB wow fadeInUp">听听他们怎么说?</p>
    <div id="Swip" ref="swiper" class="'swiper-container + this._uid' swiper-container1  wow fadeInUp">
      <div class="swiper-wrapper">
        <div
          v-for="(review, index) in reviews"
          :key="index"
          class="swiper-slide"
        >
          <p class="review-content">
            <span class="quote-icon">“</span>{{ review.content }}
          </p>
          <div class="author-info">
            <p>{{ review.author }} &nbsp;&nbsp; {{ review.position }}</p>
            {{ review.institution }}
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.css";

export default {
  data() {
    return {
    };
  },
  props: {
    reviews: {
      type: Array,
      default: () => [],
    },
  },
  // props: {
  //   slidesPerView: {
  //     type: Number,
  //     default: 1,
  //   },
  // },
  mounted() {
    new Swiper(this.$refs.swiper, {
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      allowTouchMove: false,
      // slidesPerView: this.slidesPerView
    });
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/xty.scss";
.review-swiper {
  background-color: #000000;
  color: white;
  text-align: center;
  padding: 150px 0 80px;
  overflow: hidden;
}

</style>